import { gql } from '@apollo/client';

export const UNDO_REDO_VERSION = gql`
  query GetUndoRedoVersion($input: getVersionHistoryInput) {
    getUndoRedoVersion(input: $input) {
      undo
      redo
    }
  }
`;

export const REDO_VERSION = gql`
query RedoVersion($input: getVersionHistoryInput) {
  redoVersion(input: $input) {
    id
    projectId
    createdAt
    updatedAt
    updatedBy
    versionId
  }
}
`;

export const REMOVE_UNDO_REDO_VERSION = gql`
query RemoveUndoRedoVersion {
  removeUndoRedoVersion {
    message
    type
  }
}
`;

export const REMOVE_VERSION_NAME = gql`
mutation RemoveVersionName($input: removeVersionNameInput) {
  removeVersionName(input: $input) {
    createdAt
    currentVersion
    id
    name
    projectId
    updatedAt
    updatedBy
    user {
      firstName
      lastName
    }
  }
}
`;

export const RESTORE_PREVIOUS_VERSION = gql`
query RevertVersion($input: viewPreviousVersionHistoryInput) {
  revertVersion(input: $input) {
    versionHistoryId
    id
    projectId
    createdAt
    updatedAt
    updatedBy
  }
}
`;

export const UNDO_VERSION = gql`
query UndoVersion($input: getVersionHistoryInput) {
  undoVersion(input: $input) {
    id
    projectId
    createdAt
    updatedAt
    updatedBy
    isActive
  }
}
`;

export const UPDATE_VERSION_NAME = gql`
mutation UpdateVersionName($input: updateVersionNameInput) {
  updateVersionName(input: $input) {
    createdAt
    currentVersion
    id
    name
    projectId
    updatedAt
    updatedBy
    user {
      firstName
      lastName
    }
  }
}
`;

export const GET_CURRENT_VERSION_DATA = gql`
query GetCurrentData($input: viewPreviousVersionHistoryInput) {
  getCurrentData(input: $input) {
    createdAt
    id
    projectId
    updatedAt
    updatedBy
    versionHistoryId
  }
}
`;

export const GET_PREVIOUS_VERSION = gql`
query ViewPreviousVersion($input: viewPreviousVersionHistoryInput) {
  viewPreviousVersion(input: $input) {
    id
    projectId
    createdAt
    updatedAt
    updatedBy
  }
}
`;

export const GET_VERSION = gql`
query GetVersions($input: getVersionHistoryInput) {
  getVersions(input: $input) {
    id
    projectId
    name
    createdAt
    updatedAt
    updatedBy
    currentVersion
    user {
      firstName
      lastName
    }
  }
}
`;
